import common from './common.json';
import hub from './hub.json';
import leads from './leads.json';
import obx from './obx.json';
import sales from './sales.json';

const en = {
  ...common,
  obx,
  sales,
  leads,
  hub,
};

export default en;
